<template>
  <div class="subscribe-lines">
    <div
      v-if="planLabel"
      class="subscribe-line"
    >
      <span>{{ planLabel }}</span>
      <span>{{ planAmountText }}</span>
    </div>
    <div
      v-if="discountText"
      class="subscribe-line is-discount"
    >
      <span>{{ discountLabel || `Discount (${appliedCode})` }}</span>
      <span>−{{ discountText }}</span>
    </div>
    <template v-if="editable">
      <form
        v-if="codeOpen && !appliedCode"
        class="subscribe-code"
        @submit.prevent="code && $emit('apply', code)"
      >
        <input
          ref="code"
          v-model.trim="code"
          type="text"
          class="subscribe-input"
          placeholder="Discount code"
          aria-label="Discount code"
        >
        <button
          type="submit"
          :disabled="!code || loading"
        >
          Apply
        </button>
      </form>
      <button
        v-else-if="appliedCode"
        type="button"
        class="subscribe-link-button"
        @click="$emit('remove')"
      >
        Remove discount code
      </button>
      <button
        v-else
        type="button"
        class="subscribe-link-button"
        @click="openCode"
      >
        Add discount code
      </button>
      <p
        v-if="codeError"
        class="subscribe-error"
      >
        {{ codeError }}
      </p>
    </template>
    <div class="subscribe-line is-total">
      <span>Due today</span>
      <span>{{ dueTodayText || '…' }}</span>
    </div>
    <div
      v-if="nextDateText"
      class="subscribe-line is-total is-next"
    >
      <span>{{ trial ? 'From' : 'Renews' }} {{ nextDateText }}</span>
      <span>{{ nextAmountText }}</span>
    </div>
    <p
      v-if="laterText"
      class="subscribe-then"
    >
      {{ laterText }}
    </p>
    <slot />
  </div>
</template>

<script>
// The order totals on the subscribe payment page: what's due today and what
// comes next, with the discount code entry. Shown in the summary card beside
// the form, and above the pay button on narrow screens where the card is hidden.
export default {
  name: 'SubscribeTotals',

  props: {
    planLabel: { type: String, default: '' },
    planAmountText: { type: String, default: '' },
    trial: { type: Boolean, default: false },
    dueTodayText: { type: String, default: '' },
    nextDateText: { type: String, default: '' },
    nextAmountText: { type: String, default: '' },
    // When a discount covers only the next payment: what later ones cost.
    laterText: { type: String, default: '' },
    discountText: { type: String, default: '' },
    discountLabel: { type: String, default: '' },
    appliedCode: { type: String, default: '' },
    codeError: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    editable: { type: Boolean, default: true }
  },

  data () {
    return {
      codeOpen: false,
      code: ''
    }
  },

  watch: {
    // Clear the entry once a code is applied or rejected.
    appliedCode () {
      this.code = ''
      this.codeOpen = false
    },

    codeError (error) {
      if (error) {
        this.code = ''
      }
    }
  },

  methods: {
    openCode () {
      this.codeOpen = true
      this.$nextTick(() => this.$refs.code && this.$refs.code.focus())
    }
  }
}
</script>
